export default (value) => {
  return parseFloat(value).toFixed(2)
}